import 'core-js/actual/array';
import { StrictMode } from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { isDevMode } from '@common/utils';
import { disableReactDevTools } from '@fvilers/disable-react-devtools';

import App from './App';

if (!isDevMode()) {
    disableReactDevTools();
}

// this is the new root API
const container = document.getElementById('root');
if (container) {
    const root = ReactDOMClient.createRoot(container);

    root.render(
        <StrictMode>
            <App />
        </StrictMode>
    );
}
